import {FaClipboardList} from "react-icons/fa";
import React, {useState} from "react";
import {ChecklistStatusModal} from "./ChecklistStatusModal";

export const ChecklistStatus = ({job, onJobUpdated}) => {
    const [show, setShow] = useState(false);
    const total = job.checklist_total || 0;
    const completed = job.checklist_completed || 0;

    let color = "grey";
    let title = "No Checklist";
    if (total > 0) {
        if (completed >= total) {
            color = "green";
            title = `Checklist Done (${completed}/${total})`;
        } else {
            color = "orange";
            title = `Checklist Pending (${completed}/${total})`;
        }
    }

    return (
        <>
            <FaClipboardList
                style={{marginLeft: "10px", cursor: "pointer", color: color}}
                size={22}
                title={title}
                onClick={(e) => {
                    e.stopPropagation();
                    setShow(true);
                }}
            />
            {show && <ChecklistStatusModal show={show} job={job} handleClose={(e) => {
                if (e) e.stopPropagation();
                setShow(false);
            }} onJobUpdated={onJobUpdated}/>}
        </>
    );
};
